module.exports = __webpack_public_path__ + "img/1_016.ea55d46b.jpg";